import React, { useCallback, useEffect, useState } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import Search from '../../shared/components/ui/Search';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import filter from '../../../modules/shared/assets/svg/filter.svg';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { AddServiceProvider } from './../components/forms/AddEditServiceProvider';
import Modal from '../../shared/components/ui/Modal';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { filterData } from '../../shared/utils/filterData';
import {
  getAllServiceProvider,
  createServiceProvider,
  getMyServiceProvider,
  getMarketPlaceServiceProvider,
  handleCheckServiceProviderDelete,
  deleteServiceProvider,
  resendEmailInvites,
  importSP,
  updateServiceProvider
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  buildReturnToFromLocation,
  navigateWithReturn
} from '../../shared/navigation';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const ServiceProviderList = () => {
  const userId = Cookies.get('userId');
  const [OpenAddUser, setOpenAddUser] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [serviceProviders, setServiceProviders] = useState();
  const [filteredData, setFilteredData] = useState();
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const { collapsed } = useSidebar();
  const [selectedIds, setSelectedIds] = useState([]);
  // pagination
  const [page, setPage] = useState(1);
  const [limit] = useState(500); // items per page
  const [activeTab, setActiveTab] = useState('myServiceProviders');
  const [selectedServiceProvider, setSelectedServiceProvider] = useState(null);
  const [modalType, setModalType] = useState('Add');
  const [cityFilter, setCityFilter] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const {
    data: allServiceProvider,
    refetch: refetchServiceProviders,
    isFetching
  } = useQuery({
    queryKey: ['serviceProvider', activeTab, page, cityFilter],
    queryFn: () =>
      activeTab === 'myServiceProviders'
        ? getMyServiceProvider(page, limit, cityFilter)
        : getMarketPlaceServiceProvider(page, limit, cityFilter)
  });

  console.log('allServiceProvider', allServiceProvider);

  // Track page view
  useEffect(() => {
    mixpanel.track('Service Provider List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (allServiceProvider?.data) {
      const flattedArray = allServiceProvider?.data?.map((item) => {
        const { user, category, ...rest } = item;
        const flatUser = user
          ? Object.entries(user).reduce((acc, [key, value]) => {
            acc[`user_${key}`] = value;
            return acc;
          }, {})
          : {};

        return {
          ...rest,
          ...flatUser,
          category_name: category?.name || 'N/A' // Add category name
        };
      });

      console.log(flattedArray, 'flattedArray');
      setServiceProviders(flattedArray);

      // Apply only search filter on frontend (city is filtered on backend)
      let filtered = flattedArray;

      if (searchQuery) {
        const lowercasedQuery = searchQuery.toLowerCase();
        filtered = filtered.filter((item) => {
          return (
            item.user_name?.toLowerCase().includes(lowercasedQuery) ||
            item.user_email?.toLowerCase().includes(lowercasedQuery) ||
            item.user_phone_number?.toLowerCase().includes(lowercasedQuery) ||
            item.type?.toLowerCase().includes(lowercasedQuery)
          );
        });
      }

      setFilteredData(filtered);
    }
  }, [allServiceProvider?.data, searchQuery]);

  console.log(serviceProviders, 'allServiceProvider');

  const { mutate: handleCreateServiceProvider } = useMutation({
    mutationFn: (payload) =>
      modalType === 'Add'
        ? createServiceProvider(payload)
        : updateServiceProvider(selectedServiceProvider?.id, payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (data) => {
      setIsSubmitting(false);
      toast.success(
        `Service Provider ${modalType === 'Edit' ? 'updated' : 'created'} successfully`
      );
      setServiceProviders([...serviceProviders, data]);
      setFilteredData([...serviceProviders, data]);
      setOpenAddUser(false);
      refetchServiceProviders();
      setModalType('Add');
      setSelectedServiceProvider();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error(
        `Error ${modalType === 'Edit' ? 'updating' : 'creating'} service provider`,
        err
      );
      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        `Error ${modalType === 'Edit' ? 'updating' : 'creating'} service provider`
      );
    }
  });

  //write the delete api call here
  const { mutate: handleDeleteServiceProvider } = useMutation({
    mutationFn: (id) => deleteServiceProvider(id),
    onSuccess: async (data) => {
      toast.success('Service Provider deleted successfully');
      refetchServiceProviders();
    },
    onError: (err) => {
      console.error('Error deleting service provider', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error deleting service provider',
        err
      );
    }
  });

  const { reset } = useForm();

  const handleSearch = (data) => {
    setSearchQuery(data);
  };

  const handleOnClickSearch = () => {
    const filtered = serviceProviders.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setSearchQuery('');
  };

  const handleToggleAddUser = () => {
    setOpenAddUser(!OpenAddUser);
    setModalType('Add');
    setSelectedServiceProvider();
  };

  const handleToggleEditUser = (id) => {
    const data = filteredData.find((item) => item.id === parseInt(id));

    if (data) {
      setSelectedServiceProvider(data);
      setOpenAddUser(!OpenAddUser);
      setModalType('Edit');
    } else {
      toast.error('Vendor Data Not Foud');
    }
  };

  const handleNavigateUser = (id) => {
    // Navigate logic here if needed
    navigateWithReturn(navigate, `/builder/serviceprovider/${id}`, {
      returnTo: buildReturnToFromLocation(location)
    });
  };

  const handleDeleteUser = (userId) => {
    // const updatedUsers = filteredData.filter(user => user.id !== userId);
    // setServiceProviders(updatedUsers);
    // setFilteredData(updatedUsers);
    handleDeleteServiceProvider(userId);
    toast.success('User deleted successfully');
  };

  const usersDataFormat = [
    'id',
    'user_name',
    'user_email',
    'user_phone_number',
    'category_name', // Update this field
    'type',
    'city',
    'invite',
    'actions'
  ];

  const onSubmit_User = (data) => {
    console.log(data, 'test data');
    handleCreateServiceProvider(data);
    refetchServiceProviders();
  };

  const handleSearchChange = useCallback((incomingQuery) => {
    setSearchQuery(incomingQuery); // Update the search query state
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setServiceProviders();
    setFilteredData();
    setCityFilter(''); // Reset city filter when changing tabs
    setSearchQuery(''); // Reset search query when changing tabs
    setPage(1); // Reset to first page
  };

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckServiceProviderDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const SP = DataList?.find((item) => parseInt(item.id) === parseInt(id));

      const SPName = SP?.user_name || 'service provider';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: SPName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: SPName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking SP', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking SP');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteServiceProvider(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Service Provider Deleted Successfully');

      // Refetch the data
      const result = await refetchServiceProviders();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting service provider', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error deleting service provider'
      );
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  const Data = filteredData
    ?.slice() // make a shallow copy to avoid mutating original state
    .sort((a, b) => {
      const nameA = a.user_name || a.user?.name || '';
      const nameB = b.user_name || b.user?.name || '';
      return nameA.localeCompare(nameB);
    })
    ?.map((item) => {
      if (!item || typeof item !== 'object') {
        console.warn('Invalid item in filteredData:', item);
        return null;
      }
      console.log(item, 'item');

      // Use transformData with the original item and usersDataFormat
      return transformData({ ...item, invite: `Invite ${item?.user_is_active}` }, usersDataFormat);
    })
    .filter(Boolean); // Remove any undefined items

  const DataList = filteredData
    ?.map((item) => {
      if (!item || typeof item !== 'object') {
        console.warn('Invalid item in filteredData:', item);
        return null;
      }
      console.log(item, 'item');

      // Use transformData with the original item and usersDataFormat
      return transformData(item, usersDataFormat);
    })
    .filter(Boolean);

  //wriet useMutation for resendEmailInvites
  const { mutate: resendInvite } = useMutation({
    mutationFn: (payload) => resendEmailInvites(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res) => {
      setIsSubmitting(false);
      console.log({ res });
      toast.success('Invite sent successfully');
      console.log('Invite sent successfully');
      await refetchServiceProviders(); // UI data update
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error sending invite');
    }
  });

  const handleResendInvite = (id) => {
    const users = filteredData?.filter((user) => parseInt(user.id) === parseInt(id));
    const email = users[0]?.user_email;
    resendInvite({ email });
  };

  const { mutate: handImportFn } = useMutation({
    mutationFn: (payload) => importSP(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Service Provider Imported Successfully');
      refetchServiceProviders();
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error Importing Service Provider', err);
      toast.error(
        err?.response?.data?.message || err?.message || 'Error Importing Service Provider'
      );
    }
  });

  const handleOnImport = (id) => {
    if (id) {
      const payload = {
        serviceProvider_id: id
      };
      handImportFn(payload);
    }
  };

  // Comprehensive list of major Indian cities
  const indianCities = React.useMemo(
    () => [
      'Agartala',
      'Agra',
      'Ahmedabad',
      'Aizawl',
      'Ajmer',
      'Akola',
      'Aligarh',
      'Alappuzha',
      'Allahabad',
      'Almora',
      'Alwar',
      'Amaravati',
      'Ambala',
      'Amravati',
      'Amritsar',
      'Anand',
      'Anantapur',
      'Asansol',
      'Aurangabad',
      'Baharampur',
      'Bahraich',
      'Ballari',
      'Bangalore',
      'Barasat',
      'Bareilly',
      'Bathinda',
      'Begusarai',
      'Belgaum',
      'Bellary',
      'Bhagalpur',
      'Bharatpur',
      'Bharuch',
      'Bhatpara',
      'Bhavnagar',
      'Bhilai',
      'Bhilwara',
      'Bhiwandi',
      'Bhiwani',
      'Bhopal',
      'Bhubaneswar',
      'Bidar',
      'Bijapur',
      'Bikaner',
      'Bilaspur',
      'Bokaro',
      'Burdwan',
      'Chandigarh',
      'Chandrapur',
      'Chennai',
      'Chhapra',
      'Coimbatore',
      'Cuttack',
      'Darbhanga',
      'Davangere',
      'Dehradun',
      'Delhi',
      'Dhanbad',
      'Dharamshala',
      'Dhule',
      'Dibrugarh',
      'Dindigul',
      'Dispur',
      'Durg',
      'Durgapur',
      'Erode',
      'Faizabad',
      'Faridabad',
      'Farrukhabad',
      'Firozabad',
      'Gandhidham',
      'Gandhinagar',
      'Gangtok',
      'Gaya',
      'Ghaziabad',
      'Goa',
      'Gopalpur',
      'Gorakhpur',
      'Gulbarga',
      'Guna',
      'Guntur',
      'Gurgaon',
      'Guwahati',
      'Gwalior',
      'Hajipur',
      'Haldia',
      'Hapur',
      'Haridwar',
      'Hazaribagh',
      'Hisar',
      'Hospet',
      'Hosur',
      'Howrah',
      'Hubli',
      'Hyderabad',
      'Imphal',
      'Indore',
      'Itanagar',
      'Jabalpur',
      'Jaipur',
      'Jalandhar',
      'Jalgaon',
      'Jammu',
      'Jamnagar',
      'Jamshedpur',
      'Jhansi',
      'Jodhpur',
      'Jorhat',
      'Junagadh',
      'Kadapa',
      'Kakinada',
      'Kalyan',
      'Kamarhati',
      'Kanpur',
      'Kannur',
      'Karaikudi',
      'Karimnagar',
      'Karnal',
      'Karur',
      'Kavaratti',
      'Khammam',
      'Khandwa',
      'Kharagpur',
      'Kirari Suleman Nagar',
      'Kishangarh',
      'Kochi',
      'Kohima',
      'Kolhapur',
      'Kolkata',
      'Kollam',
      'Korba',
      'Kota',
      'Kottayam',
      'Kozhikode',
      'Kumbakonam',
      'Kurnool',
      'Latur',
      'Loni',
      'Lucknow',
      'Ludhiana',
      'Madurai',
      'Maheshtala',
      'Malegaon',
      'Mangalore',
      'Mathura',
      'Mau',
      'Medinipur',
      'Meerut',
      'Mirzapur',
      'Moradabad',
      'Morbi',
      'Mumbai',
      'Munger',
      'Muzaffarnagar',
      'Muzaffarpur',
      'Mysore',
      'Nadiad',
      'Nagercoil',
      'Nagpur',
      'Naihati',
      'Nanded',
      'Nandyal',
      'Nashik',
      'Navi Mumbai',
      'Nellore',
      'New Delhi',
      'Nizamabad',
      'Noida',
      'Ongole',
      'Orai',
      'Pali',
      'Palwal',
      'Panaji',
      'Panipat',
      'Parbhani',
      'Patiala',
      'Patna',
      'Pilibhit',
      'Pimpri-Chinchwad',
      'Pondicherry',
      'Porbandar',
      'Port Blair',
      'Puducherry',
      'Pune',
      'Puri',
      'Purnia',
      'Raebareli',
      'Raichur',
      'Raigarh',
      'Raipur',
      'Rajahmundry',
      'Rajapalayam',
      'Rajkot',
      'Ramagundam',
      'Rampur',
      'Ranchi',
      'Ratlam',
      'Raurkela',
      'Rewari',
      'Rohtak',
      'Roorkee',
      'Rourkela',
      'Sagar',
      'Saharanpur',
      'Salem',
      'Sambalpur',
      'Sangli',
      'Satara',
      'Satna',
      'Secunderabad',
      'Shahjahanpur',
      'Shillong',
      'Shimla',
      'Shimoga',
      'Sikar',
      'Silchar',
      'Siliguri',
      'Silvassa',
      'Singrauli',
      'Sirsa',
      'Sitapur',
      'Siwan',
      'Solapur',
      'Sonipat',
      'South Dumdum',
      'Sri Ganganagar',
      'Srinagar',
      'Sultanpur',
      'Surat',
      'Surendranagar',
      'Suryapet',
      'Thane',
      'Thanjavur',
      'Thiruvananthapuram',
      'Thrissur',
      'Tindivanam',
      'Tirunelveli',
      'Tirupati',
      'Tiruppur',
      'Tiruchirappalli',
      'Tiruvallur',
      'Tiruvannamalai',
      'Tumkur',
      'Udaipur',
      'Udupi',
      'Ujjain',
      'Ulhasnagar',
      'Unnao',
      'Vadodara',
      'Valsad',
      'Varanasi',
      'Vasai-Virar',
      'Vellore',
      'Vijayawada',
      'Visakhapatnam',
      'Vizianagaram',
      'Warangal',
      'Yamuna Nagar'
    ],
    []
  );

  // Get city options for dropdown
  const cityOptions = React.useMemo(() => {
    return [
      { id: '', label: cityFilter ? 'Clear Filter' : 'Select City' },
      ...indianCities.map((city) => ({
        id: city,
        label: city
      }))
    ];
  }, [indianCities, cityFilter]);

  const handleCityFilterChange = (cityValue) => {
    setCityFilter(cityValue);
    setPage(1); // Reset to first page when filter changes
  };

  return (
    <>
      {/* Add service provider form */}
      {OpenAddUser && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={60}
          name={modalType === 'Add' ? 'Add Service Provider' : 'Edit Service Provider'}
          onClose={handleToggleAddUser}>
          <AddServiceProvider
            isSubmitting={isSubmitting}
            modalType={modalType}
            onSubmit={onSubmit_User}
            onClose={handleToggleAddUser}
            selectedServiceProvider={selectedServiceProvider}
            setSelectedServiceProvider={setSelectedServiceProvider}
            setModalType={setModalType}
            setOpenAddUser={setOpenAddUser}
            OpenAddUser={OpenAddUser}
            refetchServiceProviders={refetchServiceProviders}
          />
        </Modal>
      )}
      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this service provider'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">Looks like there are some assigned tasks.</p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'service provider'}
            onClose={() => setCanDelete(null)}
            data={DataList}
            type={'serviceProvider'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}
      <Layout>
        {/* Header */}
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
            }`}>
          <Header data={{ name: 'Service Providers' }} />
        </div>

        <div className={`transition-all duration-300 ease-in-out ${collapsed ? 'ml-[1vw]' : ''}`}>
          {/* Search and Add button bar */}
          <div
            className={`flex z-20 items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
              }`}>
            <Search
              onChange={handleSearchChange}
              query={searchQuery}
              onClick={handleOnClickSearch}
            />
            <div className="flex gap-5 cursor-pointer">
              {activeTab === 'myServiceProviders' && (
                <Button onClick={handleToggleAddUser}>Add Service Provider</Button>
              )}
            </div>
          </div>

          {/* Tabs */}
          <div
            className={`fixed top-[8rem] z-30 bg-white px-6 py-4    transition-all duration-300 ease-in-out ${collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
              }`}>
            <div className="flex gap-8">
              <button
                className={`text-lg font-semibold transition-colors duration-200 ${activeTab === 'myServiceProviders'
                    ? 'text-[#2A565E]'
                    : 'text-gray-400 hover:text-gray-600'
                  }
                  `}
              // onClick={() => handleTabChange('myServiceProviders')}
              >
                My Service Providers
              </button>

              {/* MarketPlace for SP */}
              {/* <button
                className={`text-lg font-semibold transition-colors duration-200 ${activeTab === 'marketplace'
                    ? 'text-[#2A565E]'
                    : 'text-gray-400 hover:text-gray-600'
                  }`}
                onClick={() => handleTabChange('marketplace')}>
                Market Place
              </button> */}
            </div>
            <div className="mt-2">
              <div
                className="h-[2px] bg-[#2A565E] transition-all duration-300"
                style={{
                  width: activeTab === 'myServiceProviders' ? '170px' : '105px',
                  transform: `translateX(${activeTab === 'myServiceProviders' ? '0' : '203px'})`
                }}
              />
            </div>
          </div>

          {/* Grid - adjusted margin top */}
          <GridWrapper width={100}>
            <div className="mt-[14rem] h-[28rem] relative">
              <Table
                headers={[
                  'Name',
                  'Email',
                  'Phone',
                  'Category',
                  'Type',
                  {
                    label: 'City',
                    dropdown: true,
                    dropdownOptions: cityOptions,
                    selectedValue: cityFilter,
                    onDropdownSelect: handleCityFilterChange
                  },
                  'Invite',
                  'Actions'
                ]}
                data={Data}
                identifier="id"
                onEdit={handleToggleEditUser}
                handleRowClick={handleNavigateUser}
                isDeleteEnable={true}
                isEditEnable={true}
                onDelete={handleCheckDelete}
                onResendInvite={(id) => handleResendInvite(id)}
                isImportEnable={activeTab !== 'myServiceProviders'}
                onImport={handleOnImport}
              />
            </div>
          </GridWrapper>
        </div>
      </Layout>
    </>
  );
};

export default ServiceProviderList;
